var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-grow-1 flex-wrap"},[_c('div',{staticClass:"d-flex align-items-center flex-column pt-4 col-12 px-3"},[_c('SummaryPoints'),_c('SummaryButton',{staticClass:"mt-auto"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }